// extracted by mini-css-extract-plugin
module.exports = {"titleHolder":"Landing_titleHolder__tHbLz","title":"Landing_title__1j0M9"};